import React from 'react';

export const SecondaryButton = ({ text }) => (
  <div className='inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-crimson bg-red-100 hover:bg-red-50 focus:outline-none focus:shadow-outline focus:border-red-300 transition duration-150 ease-in-out'>
    {text}
  </div>
);
